import React from 'react'
import Img from 'gatsby-image'

import Banner from '../../components/banner'
import Layout from '../../components/layouts/mainLayout'
import RosterCard from '../../components/roster-card'
import { roster13U } from '../../components/data'

//Images

const Rosters13U = () => {
    return (

        <Layout>
            <Banner 
                title="13U ROSTER" 
                subtitle2="Roster Coming 2021"
                // img={BannerImg}
                height="small"
            />
            <div className="team-photo">
                <Img fluid={"data.BannerImg.childImageSharp.fluid"} />
            </div>
            <div className="roster-list">
                {roster13U.map((player) => 
                    <>
                        <RosterCard 
                            img={player.img}
                            name={player.name}
                            number={player.number}
                            position={player.position}
                            team={player.team}
                            class={player.class}
                        />
                        <div className="linebreak"></div>
                    </>
                )}
            </div>
        </Layout>
        
    )
}

export default Rosters13U
